export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14139.b3cc3dd7.jpg";